<script setup lang="ts">
import CommonDialog from '@/components/common/dialog/CommonDialog.vue'
import { useMemberDeleteConfirmDialog } from '@/composables/memberManagement/useMemberDeleteConfirmDialog'
import { setLoadingView } from '@/features/miiaFw/utils/miiaFwUtils'
import { ref } from 'vue'
import { GlobalError } from '@/utils/globalError/GlobalError'
import { ERROR_CODES } from '@/constants/error/errorCode'

const { checkedItems } = defineProps<{ checkedItems: string[] }>()
const { openDialog, deleteUser } = useMemberDeleteConfirmDialog()

defineExpose({
  openDialog
})
const commonDialog = ref<InstanceType<typeof CommonDialog> | null>(null)

/**
 * ユーザー削除処理を実行する関数。
 * 親コンポーネントから渡された checkedItems を使用して削除を行う。
 */
async function onDelete() {
  try {
    setLoadingView(true)
    // 同時処理数
    const concurrency = 3
    for (let i = 0; i < checkedItems.length; i += concurrency) {
      // 3件ずつのスライスを作成
      const batch = checkedItems.slice(i, i + concurrency)
      // batch内のdeleteUserをPromise.allで並列実行し完了まで待つ
      await Promise.all(batch.map(userId => deleteUser(userId)))
    }
    // 登録処理成功後に明示的にモーダルを閉じる処理
    commonDialog.value?.handleOkConfirmed()
  } catch (e) {
    throw GlobalError.chainError(e, ERROR_CODES._811304_DELETE_USER_ERROR)
  } finally {
    setLoadingView(false)
  }
}
</script>
<template>
  <CommonDialog
    size="md"
    ref="commonDialog"
    okTitle="削除"
    cancelTitle="閉じる"
    variant="danger"
    :isEmitOkEvent="true"
    @ok-event="onDelete"
  >
    <template #header> <h3 class="w-100 text-center">ユーザー削除確認</h3></template>
    <div class="container">
      <div>{{ `選択された${checkedItems.length}件のユーザーを削除します。` }}</div>
      <div>削除を実行すると元に戻すことはできませんがよろしいですか？</div>
    </div>
  </CommonDialog>
</template>

<style lang="scss" scoped></style>
